import React from 'react';
import PropTypes from 'prop-types';
import { ANALYTICS_GOAL, useReachGoal } from '@src/libs/hooks/useReachGoal';

import Header from '..';

const HeaderCPlain = ({ isDesktopNonSticky }) => {
	const { reachGoal } = useReachGoal();
	const handleClickFav = React.useCallback(() => {
		reachGoal(ANALYTICS_GOAL.click_favorites_btn);
	}, [reachGoal]);

	return (
		<Header
			adaptive="static"
			isLinkOnLogo
			isPlain
			isDesktopNonSticky={isDesktopNonSticky}
			onClickFav={handleClickFav}
		/>
	);
};

export default HeaderCPlain;

HeaderCPlain.propTypes = {
	isDesktopNonSticky: PropTypes.bool,
};

HeaderCPlain.defaultProps = {
	isDesktopNonSticky: false,
};
